import { render, staticRenderFns } from "./SysSettings.vue?vue&type=template&id=b360419e"
import script from "./SysSettings.vue?vue&type=script&lang=js"
export * from "./SysSettings.vue?vue&type=script&lang=js"
import style0 from "./SysSettings.vue?vue&type=style&index=0&id=b360419e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports